import { type QueryClient } from '@tanstack/react-query';

import { type Counterparty, counterpartyGetCounterpartyQueryKey, counterpartyListCounterparties } from '@column/api';

const BATCH_SIZE = 100;

export const prefetchCounterpartiesByIds = async (queryClient: QueryClient, counterpartyIds: string[]) => {
  const uniqueIds = Array.from(new Set(counterpartyIds.filter(Boolean)));

  for (let i = 0; i < uniqueIds.length; i += BATCH_SIZE) {
    const ids = uniqueIds.slice(i, i + BATCH_SIZE);
    const { data } = await counterpartyListCounterparties({
      query: { counterparty_ids: ids.join(','), limit: BATCH_SIZE },
      throwOnError: false,
    });
    (data?.counterparties ?? []).forEach((cp: Counterparty) => {
      if (!cp.id) return;
      queryClient.setQueryData<Counterparty>(
        counterpartyGetCounterpartyQueryKey({ path: { counterparty_id: cp.id } }),
        cp
      );
    });
  }
};
